import { useEffect } from 'react';
import { useLocation } from 'react-router';

function ScrollToTop(props) {
  const location = useLocation();
  useEffect(() => {
    document.body.scrollTop = 0;
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return props.children;
}

export default ScrollToTop;
